import React, { Component } from 'react';
import { compose } from 'recompose';
import { Trans } from 'react-i18next';
import { MenuItem } from '@material-ui/core';

import { FeedKey } from 'api';
import {
  IRefetcher,
  IWithContent,
  IWithNotify,
  IWithQueryParams,
  RefetcherConsumer,
  withContent,
  withNotify,
  withQueryParams,
} from 'providers';
import { FollowToggle, IFollowToggleRenderProps } from 'components';
import { getFullName } from 'helpers';

interface IProps {
  onClose: () => void;
}

interface IPropsEnhanced extends IProps, IWithQueryParams, IWithContent, IWithNotify {}

const enhancers = compose<IPropsEnhanced, IProps>(withContent, withQueryParams, withNotify);

class UserFollowToggle extends Component<IPropsEnhanced> {
  getMenuKey(isFollowing: boolean) {
    return isFollowing ? 'content:postUnfollow' : 'content:postFollow';
  }

  getNotifyKey(isFollowing: boolean) {
    return isFollowing ? 'content:postUnfollowed' : 'content:postFollowed';
  }

  getCreatorName() {
    const { content } = this.props;
    return getFullName(content.user);
  }

  handleClick = (renderProps: IFollowToggleRenderProps, schedule: IRefetcher['schedule']) => () => {
    const { notify, onClose, variables } = this.props;
    const { isFollowing, onClick } = renderProps;

    const notifyKey = this.getNotifyKey(isFollowing);
    const name = this.getCreatorName();

    notify.info({ i18n: { i18nKey: notifyKey, values: { name } } });
    onClick().then(() => schedule(variables.id));
    onClose();
  };

  render() {
    const { content } = this.props;

    return (
      <FollowToggle source={content.user} type={FeedKey.User}>
        {followToggleRenderProps => {
          const i18nKey = this.getMenuKey(followToggleRenderProps.isFollowing);
          const name = this.getCreatorName();

          return (
            <RefetcherConsumer>
              {({ schedule }) => (
                <MenuItem onClick={this.handleClick(followToggleRenderProps, schedule)}>
                  <Trans i18nKey={i18nKey} values={{ name }} />
                </MenuItem>
              )}
            </RefetcherConsumer>
          );
        }}
      </FollowToggle>
    );
  }
}

export default enhancers(UserFollowToggle);
